var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.customData)?_c('span',{staticClass:"text-link-blue fake-link",on:{"click":function($event){$event.preventDefault();return _vm.onClick(_vm.params.customData.id)}}},[_vm._v(" "+_vm._s(_vm.params.customData.label)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }